<!-- Usamos el pipe 'async' para suscribirnos automáticamente al observable isLoading$ -->
@if (isLoading$ | async) {
  <div class="spinner-overlay">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
}

